import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Send, ClipboardList, CalendarDays, CheckSquare, LayoutGrid, Sparkles, FileText, BarChart3, SlidersHorizontal } from 'lucide-react';

const ICONS = { apply: Send, 'my-leaves': ClipboardList, calendar: CalendarDays, approvals: CheckSquare, availability: LayoutGrid, holidays: Sparkles, policies: FileText, reports: BarChart3, adjustments: SlidersHorizontal };

// LEAVE-UI-001: white tab bar with icons + sliding purple indicator. Visibility rules stay in MyWorkspace.
export const LeaveSubTabs = ({ tabs, active, onChange }) => {
  const refs = useRef({});
  const [ink, setInk] = useState({ left: 0, width: 0 });
  const measure = () => { const el = refs.current[active]; if (el) setInk({ left: el.offsetLeft, width: el.offsetWidth }); };
  useLayoutEffect(measure, [active, tabs.length]);
  useEffect(() => { window.addEventListener('resize', measure); return () => window.removeEventListener('resize', measure); }, [active]);
  return (
    <div className="lv-card an-rise overflow-x-auto" style={{ animationDelay: '60ms' }} data-testid="leave-subtabs">
      <nav className="relative flex items-center gap-0.5 min-w-max px-1.5" role="tablist">
        {tabs.map(t => {
          const Icon = ICONS[t.id] || CalendarDays;
          const isActive = active === t.id;
          return (
            <button key={t.id} type="button" role="tab" aria-selected={isActive} ref={el => { refs.current[t.id] = el; }}
              onClick={() => onChange(t.id)} data-testid={`leave-subtab-${t.id}`}
              className={`lv-tab flex items-center gap-2 px-3.5 h-11 text-[13px] font-semibold whitespace-nowrap rounded-lg ${isActive ? 'text-violet-600' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`}>
              <Icon className={`h-4 w-4 ${isActive ? 'text-violet-600' : 'text-slate-400'}`} strokeWidth={1.9} />
              {t.label}
            </button>
          );
        })}
        <span className="lv-tab-ink absolute bottom-0 h-[3px] rounded-full bg-gradient-to-r from-violet-600 to-indigo-500" style={{ left: ink.left, width: ink.width }} aria-hidden="true" data-testid="leave-subtab-indicator" />
      </nav>
    </div>
  );
};

export default LeaveSubTabs;
